module.exports = __webpack_public_path__ + "img/file-play.656f605b.svg";